import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import TFUSelect from "../based/inputs/TFUSelect";
import CommonServices from "../based/services/CommonServices";

function EditBankAccountModal({ show, onClose, onConfirm }) {
    const [lstBank, setListBank] = useState([]);
    const [bankData, setBankData] = useState({});

    useEffect(() => {
        if (show) {
            getBankList();
        }
    }, [show]);

    const getBankList = async () => {
        const [err, data] = await CommonServices.GetBanks();
        if (!err && data) {
            setListBank(data);
        } else {
            setListBank([]);
        }
    };

    return (
        <CommonModal
            size="md"
            show={show}
            onClose={onClose}
            onConfirm={() => {
                onConfirm(bankData);
            }}
            title="Số tài khoản"
        >
            <Wrapper>
                <div className="form-group">
                    <label htmlFor="bank">Ngân hàng</label>
                    <TFUSelect
                        id="bank"
                        placeholder="Chọn ngân hàng"
                        options={lstBank}
                        value={bankData.bankCode}
                        onChangedObject={(item) => {
                            setBankData({ ...bankData, bankCode: item.value, bankName: item.label });
                        }}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="bankAccountNumber">Số tài khoản</label>
                    <input
                        type="text"
                        id="bankAccountNumber"
                        placeholder="Nhập số tài khoản"
                        value={bankData.bankAccountNumber || ""}
                        onChange={(e) => {
                            setBankData({ ...bankData, bankAccountNumber: e.target.value });
                        }}
                        className="form-control"
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="bankAccountName">Tên chủ tài khoản</label>
                    <input
                        type="text"
                        id="bankAccountName"
                        placeholder="Nhập tên chủ tài khoản"
                        value={bankData.bankAccountName || ""}
                        onChange={(e) => {
                            setBankData({ ...bankData, bankAccountName: e.target.value });
                        }}
                        className="form-control"
                    />
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default EditBankAccountModal;

const Wrapper = styled.div``;
